import { r as registerInstance, h, H as Host } from './index-6f037ff9.js';
import { g as getUniqueId, D as Direction, c as convertPixelsToRem } from './utils-7a0a66d5.js';

const infoIconOrangeSvg = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9Ijh1bjJ3Y3VmN2EiPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDAuNzU2ODYzIDAgMCAwIDAgMC41MDU4ODIgMCAwIDAgMCAwLjAwMzkyMiAwIDAgMCAxLjAwMDAwMCAwIi8+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGcgZmlsdGVyPSJ1cmwoIzh1bjJ3Y3VmN2EpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjQ4IC00NDgpIHRyYW5zbGF0ZSg0MDAgMTY4KSB0cmFuc2xhdGUoMjQ4IDI4MCkiPgogICAgICAgICAgICAgICAgICAgIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj4KICAgICAgICAgICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiLz4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTggMTEuMkw4IDhNOCA0LjhMOC4wMDggNC44Ii8+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K';

const tooltipCss = "@charset \"UTF-8\";:host{--_tooltip-bg-color:var(--tooltip-bg-color, white)}:host{display:-ms-flexbox;display:flex;height:100%}:host .top-left:before{content:\"\";position:absolute;top:0rem;left:1.25rem;width:0rem;height:0rem;z-index:1000;-webkit-transform:translate(-50%, 0rem);transform:translate(-50%, 0rem);border-style:solid;border-width:0.625rem 0.625rem 0rem 0.625rem;border-color:var(--tooltip-bg-color) transparent transparent transparent}:host .top-right:before{content:\"\";position:absolute;top:0rem;left:0rem;width:0rem;height:0rem;z-index:1000;-webkit-transform:translate(50%, 0rem);transform:translate(50%, 0rem);border-style:solid;border-width:0.625rem 0.625rem 0rem 0.625rem;border-color:var(--tooltip-bg-color) transparent transparent transparent}:host .bottom-left:before{content:\"\";position:absolute;bottom:0rem;left:1.25rem;width:0rem;height:0rem;z-index:1000;-webkit-transform:translate(-50%, 0rem);transform:translate(-50%, 0rem);border-style:solid;border-width:0rem 0.625rem 0.625rem 0.625rem;border-color:transparent transparent var(--tooltip-bg-color) transparent}:host .bottom-right:before{content:\"\";position:absolute;bottom:0rem;left:0rem;width:0rem;height:0rem;z-index:1000;-webkit-transform:translate(50%, 0rem);transform:translate(50%, 0rem);border-style:solid;border-width:0rem 0.625rem 0.625rem 0.625rem;border-color:transparent transparent var(--tooltip-bg-color) transparent}:host .default:after{position:fixed;bottom:auto;top:50%;left:50%}:host ::slotted([slot=img]){width:6rem;height:3.5rem;margin-bottom:0.625rem}:host ::slotted([slot=title]){font-weight:bold}:host ::slotted([slot=text]){margin:0rem;margin-top:0.5rem}:host ::slotted([slot=text-fieldset]){margin:0rem}:host .input__tooltip{position:relative;-ms-flex-item-align:center;align-self:center;padding-left:0.5rem;}:host .input__tooltip .input__tooltip-container{z-index:999}:host .input__tooltip--fieldset{display:block}:host .input__tooltip-container{font-family:var(--tooltip-font-family);font-size:0.875rem;line-height:1.25rem;color:var(--tooltip-color);width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:18.75rem;background-color:var(--tooltip-bg-color);padding:1rem;border-radius:0.5rem;-webkit-box-shadow:0rem 0.125rem 0.875rem 0rem rgba(179, 176, 176, 0.5);box-shadow:0rem 0.125rem 0.875rem 0rem rgba(179, 176, 176, 0.5);display:none;-ms-flex-direction:column;flex-direction:column;position:absolute;overflow:auto}:host .input__tooltip-container--fieldset{z-index:999}:host .input__tooltip-container--fieldset .input__tooltip-text{font-family:var(--tooltip-font-family);font-size:0.875rem;line-height:1.25rem;color:var(--tooltip-color);font-weight:normal}:host .input__tooltip-container--fieldset .input__tooltip-text-list{list-style:none;margin:0rem;padding:0rem;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}:host .input__tooltip-container--fieldset .input__tooltip-text-item{display:-ms-flexbox;display:flex}:host .input__tooltip-container--fieldset .input__tooltip-text-item::before{content:\"•\";padding-right:0.5625rem;color:#3e74b4}:host .input__tooltip-container--fieldset .input__tooltip-text ul{list-style:none;margin:0rem;padding:0rem;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}:host .input__tooltip-container--fieldset .input__tooltip-text li{display:-ms-flexbox;display:flex}:host .input__tooltip-container--fieldset .input__tooltip-text li::before{content:\"•\";padding-right:0.5625rem;color:#3e74b4}:host .input__tooltip-container.opened{display:-ms-flexbox;display:flex}:host .input__tooltip-container::-webkit-scrollbar{width:0.25rem;height:98%}:host .input__tooltip-container::-webkit-scrollbar-track{background:transparent;margin-top:0.25rem;margin-bottom:0.25rem}:host .input__tooltip-container::-webkit-scrollbar-thumb{background:#ccc;border-radius:0.625rem}:host .input__tooltip-container::-webkit-scrollbar-thumb:hover{background:#ccc}:host .input__tooltip-button{display:block;border-style:none;background-color:transparent;padding:0rem;width:1.5rem;cursor:pointer}:host .input__tooltip-img{width:1.5rem}:host .sr-only{position:absolute;width:0.0625rem;height:0.0625rem;padding:0rem;margin:-0.0625rem;overflow:hidden;clip:rect(0rem, 0rem, 0rem, 0rem);border:0rem}";

const Tooltip = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isOpen = false;
    this.hasFocus = false;
    this.isMouseHover = false;
    this.VERTICAL_MARGIN = 16;
    this.LEFT_MARGIN = 8;
  }
  async onViewportChanges() {
    if (this.isOpen) {
      this.showTooltip();
    }
  }
  componentWillLoad() {
    this.uniqueId = this.eid ? this.eid : getUniqueId('support-tip');
  }
  componentDidLoad() { }
  componentDidUpdate() {
    const buttonRect = this.button.getBoundingClientRect();
    //resetear maxHeight cada vez que se pinte el tooltip
    this.tooltip.style.maxHeight = 'none';
    const tooltipRect = this.tooltip.getBoundingClientRect();
    const direction = this.getBestDirection(buttonRect);
    this.placeTooltip(direction, tooltipRect, buttonRect);
  }
  handleOnFocus() {
    this.hasFocus = true;
    if (this.isOpen) {
      return;
    }
    this.showTooltip();
  }
  handleOnMouseEnter() {
    this.isMouseHover = true;
    if (this.isOpen) {
      return;
    }
    this.showTooltip();
  }
  handleOnMouseLeave() {
    this.isMouseHover = false;
    if (!this.isOpen || this.hasFocus) {
      return;
    }
    this.hideTooltip();
  }
  handleOnBlur() {
    this.hasFocus = false;
    if (!this.isOpen || this.isMouseHover) {
      return;
    }
    this.hideTooltip();
  }
  handleOnTooltipMouseEnter() {
    this.isMouseHover = true;
    if (this.isOpen) {
      return;
    }
  }
  handleOnTooltipMouseLeave() {
    this.isMouseHover = false;
    if (!this.isOpen || this.hasFocus) {
      return;
    }
    this.hideTooltip();
  }
  handleOnWheel(event) {
    event.preventDefault();
    var scrollHeight = this.tooltip.scrollHeight;
    var maxScroll = scrollHeight - this.tooltip.clientHeight;
    this.tooltip.scrollTop += event.deltaY;
    if (this.tooltip.scrollTop < 0) {
      this.tooltip.scrollTop = 0;
    }
    else if (this.tooltip.scrollTop > maxScroll) {
      this.tooltip.scrollTop = maxScroll;
    }
  }
  showTooltip() {
    this.isOpen = true;
  }
  hideTooltip() {
    this.button.classList.remove('bottom-left', 'bottom-right', 'top-left', 'top-right');
    this.isOpen = false;
  }
  getBestDirection(position) {
    const spaceBottom = window.innerHeight - (position.bottom + this.VERTICAL_MARGIN);
    const spaceTop = position.top - this.VERTICAL_MARGIN;
    const spaceRight = window.innerWidth - position.right;
    const spaceLeft = position.left - this.LEFT_MARGIN;
    if (spaceBottom >= spaceTop && spaceLeft >= spaceRight) {
      return Direction.BOTTOM_LEFT;
    }
    else if (spaceTop >= spaceBottom && spaceLeft >= spaceRight) {
      return Direction.TOP_LEFT;
    }
    else if (spaceTop >= spaceBottom && spaceRight >= spaceLeft) {
      return Direction.TOP_RIGHT;
    }
    else {
      return Direction.BOTTOM_RIGHT;
    }
  }
  placeTooltip(direction, tooltipSize, buttonSize) {
    if (this.isOpen) {
      const windowHeight = window.innerHeight;
      switch (direction) {
        case Direction.TOP_RIGHT:
          this.tooltip.style.top = `-${convertPixelsToRem(tooltipSize.height)}rem`;
          this.tooltip.style.right = 'auto';
          this.tooltip.style.bottom = 'auto';
          this.tooltip.style.left = 'auto';
          this.button.classList.remove('bottom-left', 'bottom-right', 'top-left');
          this.button.classList.add('top-right');
          var rect = this.tooltip.getBoundingClientRect();
          var tooltipHeight = this.tooltip.offsetHeight;
          if (rect.top < 0) {
            this.tooltip.style.top = `${convertPixelsToRem(10)}rem`;
            this.tooltip.style.maxHeight = `${convertPixelsToRem(rect.bottom - 40)}rem`;
          }
          break;
        case Direction.BOTTOM_RIGHT:
          this.tooltip.style.top = 'auto';
          this.tooltip.style.right = 'auto';
          this.tooltip.style.bottom = 'auto';
          this.tooltip.style.left = 'auto';
          this.button.classList.remove('top-right', 'bottom-left', 'top-left');
          this.button.classList.add('bottom-right');
          var rect = this.tooltip.getBoundingClientRect();
          var tooltipHeight = this.tooltip.offsetHeight;
          if (rect.bottom + tooltipHeight > windowHeight) {
            const navigationBar = document.querySelector('.imv-navigation');
            const navigationBarHeight = navigationBar !== null ? navigationBar.getBoundingClientRect().height : 0;
            const marginToBottom = navigationBar !== null ? navigationBarHeight : 10;
            const tooltipPaddingTop = parseInt(getComputedStyle(this.tooltip).paddingTop);
            const tooltipPaddingBottom = parseInt(getComputedStyle(this.tooltip).paddingBottom);
            this.tooltip.style.maxHeight = `${convertPixelsToRem(windowHeight - rect.top - (tooltipPaddingTop + tooltipPaddingBottom) - marginToBottom)}rem`;
          }
          break;
        case Direction.BOTTOM_LEFT:
          this.tooltip.style.top = 'auto';
          this.tooltip.style.right = 'auto';
          this.tooltip.style.bottom = 'auto';
          this.tooltip.style.left = `-${convertPixelsToRem(tooltipSize.width - this.VERTICAL_MARGIN - buttonSize.width)}rem`;
          this.button.classList.remove('top-right', 'bottom-right', 'top-left');
          this.button.classList.add('bottom-left');
          var rect = this.tooltip.getBoundingClientRect();
          var tooltipHeight = this.tooltip.offsetHeight;
          if (rect.bottom + tooltipHeight > windowHeight) {
            const navigationBar = document.querySelector('.imv-navigation');
            const navigationBarHeight = navigationBar !== null ? navigationBar.getBoundingClientRect().height : 0;
            const marginToBottom = navigationBar !== null ? navigationBarHeight : 10;
            const tooltipPaddingTop = parseInt(getComputedStyle(this.tooltip).paddingTop);
            const tooltipPaddingBottom = parseInt(getComputedStyle(this.tooltip).paddingBottom);
            this.tooltip.style.maxHeight = `${convertPixelsToRem(windowHeight - rect.top - (tooltipPaddingTop + tooltipPaddingBottom) - marginToBottom)}rem`;
          }
          break;
        case Direction.TOP_LEFT:
          this.tooltip.style.top = `-${convertPixelsToRem(tooltipSize.height)}rem`;
          this.tooltip.style.right = 'auto';
          this.tooltip.style.bottom = 'auto';
          this.tooltip.style.left = `-${convertPixelsToRem(tooltipSize.width - this.VERTICAL_MARGIN - buttonSize.width)}rem`;
          this.button.classList.remove('top-right', 'bottom-right', 'bottom-left');
          this.button.classList.add('top-left');
          var rect = this.tooltip.getBoundingClientRect();
          var tooltipHeight = this.tooltip.offsetHeight;
          if (rect.top < 0) {
            this.tooltip.style.top = `${convertPixelsToRem(10)}rem`;
            this.tooltip.style.maxHeight = `${convertPixelsToRem(rect.bottom - 40)}rem`;
          }
          break;
        default:
          this.tooltip.style.top = 'auto';
          this.tooltip.style.right = 'auto';
          this.tooltip.style.bottom = 'auto';
          this.tooltip.style.left = 'auto';
          this.button.classList.remove('top-right', 'bottom-right', 'bottom-left', 'top-left');
          this.button.classList.add('default');
      }
      //Evita desbordamientos del tooltip por los laterales
      const rectAfterPos = this.tooltip.getBoundingClientRect();
      if (rectAfterPos.left < 0 || rectAfterPos.right > window.innerWidth) {
        const tooltipPaddingLeft = parseInt(getComputedStyle(this.tooltip).paddingLeft);
        const tooltipPaddinRight = parseInt(getComputedStyle(this.tooltip).paddingRight);
        if (rectAfterPos.left < 0) {
          const tooltipRelativeLeft = parseInt(getComputedStyle(this.tooltip).left);
          this.tooltip.style.left = `${convertPixelsToRem(tooltipRelativeLeft - rectAfterPos.left)}rem`;
          const tooltipMaxWidth = window.innerWidth - (tooltipPaddingLeft + tooltipPaddinRight);
          this.tooltip.style.maxWidth = `${convertPixelsToRem(tooltipMaxWidth)}rem`;
        }
        if (rectAfterPos.right > window.innerWidth) {
          const tooltipMaxWidth = window.innerWidth - rectAfterPos.left - (tooltipPaddingLeft + tooltipPaddinRight);
          this.tooltip.style.maxWidth = `${convertPixelsToRem(tooltipMaxWidth)}rem`;
        }
      }
    }
  }
  renderTooltip() {
    if (this.fieldset) {
      return (h(Host, null, h("div", { class: "input__tooltip input__tooltip--fieldset", role: "tooltip" }, h("button", { ref: el => (this.button = el), class: "input__tooltip-button input__tooltip-button--fieldset", onMouseEnter: () => this.handleOnMouseEnter(), onFocus: () => this.handleOnFocus(), onMouseLeave: () => this.handleOnMouseLeave(), onBlur: () => this.handleOnBlur(), onWheel: e => this.handleOnWheel(e) }, h("img", { class: "input__tooltip-img", src: infoIconOrangeSvg, alt: "", role: "presentation" })), h("div", { class: `input__tooltip-container ${this.isOpen ? 'opened' : ''} input__tooltip-container--fieldset`, role: "tooltip", id: this.uniqueId, "aria-hidden": "true", "aria-haspopup": "true", ref: el => (this.tooltip = el), onMouseEnter: () => this.handleOnTooltipMouseEnter(), onMouseLeave: () => this.handleOnTooltipMouseLeave() }, h("slot", { name: "text-fieldset" }), h("div", { class: "input__tooltip-text", innerHTML: this.text })))));
    }
    else {
      return (h(Host, null, h("div", { class: "input__tooltip", role: "tooltip" }, h("button", { ref: el => (this.button = el), class: "input__tooltip-button", onMouseEnter: () => this.handleOnMouseEnter(), onFocus: () => this.handleOnFocus(), onMouseLeave: () => this.handleOnMouseLeave(), onBlur: () => this.handleOnBlur(), onWheel: e => this.handleOnWheel(e), "aria-describedby": this.uniqueId }, h("img", { class: "input__tooltip-img", src: infoIconOrangeSvg, alt: "", role: "presentation" })), h("div", { class: `input__tooltip-container ${this.isOpen ? 'opened' : ''}`, role: "tooltip", id: this.uniqueId, "aria-haspopup": "true", ref: el => (this.tooltip = el), onMouseEnter: () => this.handleOnTooltipMouseEnter(), onMouseLeave: () => this.handleOnTooltipMouseLeave() }, h("slot", { name: "img" }), h("slot", { name: "title" }), h("slot", { name: "text" })))));
    }
  }
  render() {
    return this.renderTooltip();
  }
};
Tooltip.style = tooltipCss;

export { Tooltip as imv_ui_tooltip };
